<template>
  <div class="base-table spacey-12">
    <div class="table-header incoming-tenders-columns grey-500 text-sm">
      <div>{{ $t('Offer version') }}</div>
      <div>{{ $t('Submitted') }}</div>
      <div>{{ $t('Total price') }}</div>
      <div>{{ $t('Attached files') }}</div>
    </div>
    <div class="spacey-20">
      <div
        v-for="(offer, idx) in offers"
        :key="idx"
        class="table-row incoming-tenders-columns grey-900"
      >
        <div class="tender-row text-sm spacex-8">
          <span>{{ $t('Offer') }} v.{{ offer.name }}</span>
          <span v-if="offer.status === 'draft'" class="grey-500">{{ $t('Draft') }}</span>
        </div>
        <div class="tender-row text-sm">
          <span v-if="offer.submitted_at">{{ prettyDates(offer.submitted_at) }}</span>
          <span v-else class="grey-500 text-sm">-</span>
        </div>
        <div class="tender-row text-sm spacex-4">
          <span class="grey-500">{{ currencySymbols[currency] }}</span>
          <span>{{ addSpaces(offer.final_budget) }}</span>
        </div>
        <div class="tender-row">
          <span v-if="offer.files.length">
            <button class="primary-600 link" @click="handleFileShowing(offer.files)">
              <AttachIcon class="primary-icon" />
              {{ $tc('file', offer.files.length) }}
            </button>
          </span>
          <span v-else class="grey-500 text-sm">-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import prettyDates from '@/utils/formatting/pretty-date';
  import addSpaces from '@/utils/formatting/add-spaces';
  import AttachIcon from '@/assets/icons/paperclip.svg';
  import AttachedFilesModal from '@/components/files/AttachedFilesModal';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'TenderCardOffers',
    components: {
      AttachIcon,
    },
    props: {
      offers: {
        type: Array,
        required: true,
      },
      currency: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      prettyDates,
      addSpaces,
      handleFileShowing(files) {
        this.openModal({
          component: AttachedFilesModal,
          context: {
            files,
          },
        });
      },
    },
  };
</script>
